import { render, staticRenderFns } from "./CustomScenarioChart.vue?vue&type=template&id=b36a51ea"
import script from "./CustomScenarioChart.vue?vue&type=script&lang=js"
export * from "./CustomScenarioChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports